module.exports = __webpack_public_path__ + "static/media/XQ1.ba05b0d7.png";